<template>
	<div class="page-container">
		<!-- 列表 -->
		<goods-list></goods-list>

		<!-- 底部 -->
		<bottom-goods-action></bottom-goods-action>

		<popup get-container="body" v-model="isShow" position="bottom" style="height: 90%" @close="close">
			<goods-popup v-if="isShow" :goodsInfo="goodsInfo" :goodsDtl="goodsDtl" @close="close" ref="goodsDtl">
			</goods-popup>
		</popup>
	</div>
</template>

<script>
	import {
		popup
	} from "vant";
	import {
		mapGetters
	} from "vuex";
	import bottomGoodsAction from './bottomGoodsAction';
	import goodsList from './goodsList';
	import goodsPopup from './goodsPopup/index.vue';
	import pageevent from './event';

	export default {
		data() {
			return {
				goodsInfo: null,
				goodsDtl: null,
				isShow: false
			}
		},
		methods: {
			close() {
				this.isShow = false;
				this.goodsDtl = null;
				this.goodsInfo = null;
			}
		},
		created() {
			// 获取信息
			this.$store.dispatch("getShoppingCart");

			// 深层组件事键监听
			pageevent.$on("showGoodsDtl", (info, dtl) => {
				this.goodsInfo = JSON.parse(JSON.stringify(info));
				this.goodsDtl = JSON.parse(JSON.stringify(dtl));
				

				this.isShow = true;
			})
		},
		computed: {
			...mapGetters({
				getStore: "getStore",
			}),
		},
		components: {
			popup,
			goodsList,
			bottomGoodsAction,
			goodsPopup
		}
	}
</script>

<style lang="scss" scoped>
	.page-container {
		flex: 1;
		display: flex;
		flex-direction: column;
		min-width: 0;
		overflow: hidden;
	}
</style>
